import React from 'react';
import ApartmentIcon from '@mui/icons-material/Apartment';
import StoreIcon from '@mui/icons-material/Store';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SettingsIcon from '@mui/icons-material/Settings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { useTenantTerminology } from './useTenantTerminology';

export interface MenuItem {
  to: string;
  icon: React.ReactElement;
  text: string;
  path: string;
}

export interface MenuSection {
  title: string;
  icon?: React.ReactElement;
  items: MenuItem[];
}

/**
 * Menu items specifically for Enterprise Admins
 * Only shows Franchise and Configuration sections
 */
export const useEnterpriseAdminMenuItems = (): MenuSection[] => {
  const { t } = useTenantTerminology();
  
  return [
    {
      title: t('menu.dashboard', 'Dashboard'),
      icon: <DashboardIcon fontSize="small" />,
      items: [
        {
          to: '/enterprises/dashboard',
          icon: <DashboardIcon />,
          text: t('menu.dashboard', 'Dashboard'),
          path: '/enterprises/dashboard',
        },
      ],
    },
    {
      title: t('menu.franchise', 'Franchise'),
      icon: <ApartmentIcon fontSize="small" />,
      items: [
        {
          to: '/enterprises',
          icon: <ApartmentIcon />,
          text: t('menu.enterprises', 'Enterprises'),
          path: '/enterprises',
        },
        {
          to: '/brands',
          icon: <StoreIcon />,
          text: t('menu.brands', 'Brands'),
          path: '/brands',
        },
        {
          to: '/regions',
          icon: <LocationOnIcon />,
          text: t('menu.regions', 'Regions'),
          path: '/regions',
        },
      ],
    },
    {
      title: t('menu.configuration', 'Configuration'),
      icon: <SettingsIcon fontSize="small" />,
      items: [
        {
          to: '/configuration',
          icon: <SettingsIcon />,
          text: t('menu.configuration', 'Configuration'),
          path: '/configuration',
        },
      ],
    },
  ];
};
